import styled from '@emotion/styled'
import dynamic from 'next/dynamic'
import { FC } from 'react'

const LanguagePicker = dynamic(() => import('./HeaderExtensions/LanguagePicker'), { ssr: false })

const SettingsControlContainer = styled.div`
    display: flex;
    align-items: center;
    margin-left: 1rem;
    color: ${({ theme }) => theme.colors.black};

    @media (max-width: ${props => props.theme.bps.md}) {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 2.5em;
    }
`

const SettingsControl: FC = () => (
    <SettingsControlContainer className="language-picker-container">
        <LanguagePicker />
    </SettingsControlContainer>
)

export default SettingsControl
